module.exports = __webpack_public_path__ + "img/JM.4a2950f5.svg";